<section id="wb-lng" class="text-right">
  <h2 class="wb-inv">Language selection</h2>
  <ul class="list-inline margin-bottom-none">
    <li><a lang="{{language.code}}" hreflang="{{language.code}}" href="/{{language.code}}{{routePath}}">{{language.label}}</a></li>
  </ul>
</section>
